import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { toast } from "./components/Toast.tsx";
import { setLang, t } from "./i18n.ts";
import { errorText } from "./meta.ts";
import { initOpsQueue } from "./opsQueue.ts";
import { engine } from "./store.ts";
import { telegramLanguage } from "./telegram.ts";
import { invalidateRemote } from "./useRemote.ts";
import "./styles.css";

setLang(telegramLanguage() ?? "ru");

void engine.start();
// Записи, сделанные без сети, уходят сами, когда появится интернет.
initOpsQueue(
  (err) => toast(t("opDropped", { reason: errorText(err) })),
  () => {
    toast(t("opsSent"));
    invalidateRemote();
  },
);
window.addEventListener("online", () => engine.wake());
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") engine.wake();
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
